import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "209.001",
  height: "208",
  viewBox: "0 0 209.001 208"
}
const _hoisted_2 = {
  id: "survey-svg-2-2-linear-gradient",
  x1: "0.5",
  x2: "0.5",
  y2: "1",
  gradientUnits: "objectBoundingBox"
}
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_5 = {
  id: "survey-svg-2-2-linear-gradient-2",
  x1: "0.5",
  x2: "0.5",
  y2: "1",
  gradientUnits: "objectBoundingBox"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("stop", {
  offset: "0",
  "stop-color": "#fff"
}, null, -1)
const _hoisted_7 = ["stop-color"]
const _hoisted_8 = {
  id: "ti_2",
  transform: "translate(-408 -117)"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  id: "减去_45",
  "data-name": "减去 45",
  d: "M-872.5-1061a105.769,105.769,0,0,1-21.061-2.113,104.348,104.348,0,0,1-19.616-6.06,104.688,104.688,0,0,1-17.751-9.589,105.158,105.158,0,0,1-15.466-12.7,104.858,104.858,0,0,1-12.76-15.392,103.849,103.849,0,0,1-9.635-17.666,103.114,103.114,0,0,1-6.089-19.522A104.284,104.284,0,0,1-977-1165a104.291,104.291,0,0,1,2.123-20.96,103.118,103.118,0,0,1,6.089-19.522,103.856,103.856,0,0,1,9.635-17.666,104.854,104.854,0,0,1,12.76-15.392,105.14,105.14,0,0,1,15.466-12.7,104.686,104.686,0,0,1,17.751-9.589,104.341,104.341,0,0,1,19.616-6.06A105.762,105.762,0,0,1-872.5-1269a105.759,105.759,0,0,1,21.06,2.113,104.347,104.347,0,0,1,19.616,6.06,104.678,104.678,0,0,1,17.751,9.589,105.142,105.142,0,0,1,15.466,12.7,104.86,104.86,0,0,1,12.76,15.392,103.851,103.851,0,0,1,9.635,17.666,103.115,103.115,0,0,1,6.089,19.522A104.289,104.289,0,0,1-768-1165a104.284,104.284,0,0,1-2.123,20.959,103.111,103.111,0,0,1-6.089,19.522,103.843,103.843,0,0,1-9.635,17.666,104.862,104.862,0,0,1-12.76,15.392,105.154,105.154,0,0,1-15.466,12.7,104.688,104.688,0,0,1-17.751,9.589,104.35,104.35,0,0,1-19.616,6.06A105.767,105.767,0,0,1-872.5-1061Zm0-205a102.741,102.741,0,0,0-20.456,2.052,101.354,101.354,0,0,0-19.053,5.885,101.668,101.668,0,0,0-17.241,9.312,102.121,102.121,0,0,0-15.022,12.333,101.846,101.846,0,0,0-12.394,14.948,100.862,100.862,0,0,0-9.358,17.156,100.133,100.133,0,0,0-5.914,18.959A101.263,101.263,0,0,0-974-1165a101.263,101.263,0,0,0,2.062,20.355,100.129,100.129,0,0,0,5.914,18.959,100.866,100.866,0,0,0,9.358,17.156,101.857,101.857,0,0,0,12.394,14.948,102.122,102.122,0,0,0,15.022,12.333,101.675,101.675,0,0,0,17.241,9.312,101.356,101.356,0,0,0,19.053,5.885A102.733,102.733,0,0,0-872.5-1064a102.732,102.732,0,0,0,20.456-2.052,101.356,101.356,0,0,0,19.052-5.885,101.67,101.67,0,0,0,17.241-9.312,102.12,102.12,0,0,0,15.022-12.333,101.839,101.839,0,0,0,12.394-14.948,100.856,100.856,0,0,0,9.358-17.156,100.125,100.125,0,0,0,5.914-18.959A101.263,101.263,0,0,0-771-1165a101.263,101.263,0,0,0-2.062-20.355,100.133,100.133,0,0,0-5.914-18.959,100.86,100.86,0,0,0-9.358-17.156,101.828,101.828,0,0,0-12.394-14.948,102.12,102.12,0,0,0-15.022-12.333,101.66,101.66,0,0,0-17.241-9.312,101.351,101.351,0,0,0-19.052-5.885A102.739,102.739,0,0,0-872.5-1266Z",
  transform: "translate(1385 1386)",
  fill: "url(#survey-svg-2-2-linear-gradient)"
}, null, -1)
const _hoisted_10 = ["fill"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  id: "联合_119",
  "data-name": "联合 119",
  d: "M-977-1219.923a41.023,41.023,0,0,1,41.047-41.046v41.046h41.046a41.023,41.023,0,0,1-41.046,41.047A41.023,41.023,0,0,1-977-1219.923Zm49.444-8.032V-1269a41.022,41.022,0,0,1,41.046,41.046Z",
  transform: "translate(1444 1432.895)",
  fill: "url(#survey-svg-2-2-linear-gradient-2)"
}, null, -1)

import { withDefaults } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'survey-svg-2-2',
  props: {
    controlColor: { default: 'var(--theme-color-1,#000)' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", _hoisted_2, [
        _createElementVNode("stop", {
          offset: "0",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_3),
        _hoisted_4
      ]),
      _createElementVNode("linearGradient", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": _ctx.controlColor
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("g", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("ellipse", {
        id: "椭圆_555",
        "data-name": "椭圆 555",
        cx: "88.5",
        cy: "88",
        rx: "88.5",
        ry: "88",
        transform: "translate(424 133)",
        fill: _ctx.controlColor
      }, null, 8, _hoisted_10),
      _hoisted_11
    ])
  ]))
}
}

})